import { Heading, ThemeColorVariable, ThemeFontSizeVariable } from "@caspeco/casper-ui-library";
import { SafeHTML } from "components/safe-html";

interface TimeSetTitleProps {
    title: string;
}

const TimeSetTitle = ({ title }: TimeSetTitleProps) => {
    return (
        <Heading
            as="h6"
            color={ThemeColorVariable.OnBackgroundHeader}
            fontSize={ThemeFontSizeVariable.Large}
            fontWeight="500"
        >
            <SafeHTML html={title} />
        </Heading>
    );
};

export default TimeSetTitle;
